import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "wrapper no-scroll-bar" }
const _hoisted_2 = { class: "header-wrapper" }
const _hoisted_3 = { style: {"width":"70px","margin-left":"auto"} }
const _hoisted_4 = { class: "pa-1 date_card" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "record-date-nav date_card" }
const _hoisted_7 = { class: "record-date-nav-side record-date-nav-side-left" }
const _hoisted_8 = { class: "primary--text record-date-nav-label" }
const _hoisted_9 = { class: "record-date-nav-center d-flex" }
const _hoisted_10 = { style: {"margin-left":"2px !important","margin-right":"2px !important"} }
const _hoisted_11 = { class: "record-date-nav-side record-date-nav-side-right" }
const _hoisted_12 = { class: "primary--text record-date-nav-label" }
const _hoisted_13 = { class: "content-wrapper no-scroll-bar" }
const _hoisted_14 = { class: "title-wrapper pa-1 px-3" }
const _hoisted_15 = {
  key: 0,
  class: "d-flex justify-center align-center pa-10"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex pa-2"
}
const _hoisted_19 = { class: "caption grey--text" }
const _hoisted_20 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_21 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_22 = { class: "d-flex flex-wrap" }
const _hoisted_23 = {
  key: 0,
  class: "pa-2"
}
const _hoisted_24 = { class: "caption grey--text mb-1" }
const _hoisted_25 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_26 = { class: "grey--text text--darken-1 mr-2" }
const _hoisted_27 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_28 = { class: "grey--text text--darken-1 mr-2" }
const _hoisted_29 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_30 = { class: "grey--text text--darken-1 mr-2" }
const _hoisted_31 = { class: "title-wrapper pa-1 px-3" }
const _hoisted_32 = {
  key: 2,
  class: "d-flex justify-center align-center pa-10"
}
const _hoisted_33 = { key: 3 }
const _hoisted_34 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_35 = { class: "px-5 py-2" }
const _hoisted_36 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_37 = { class: "px-5 py-2" }
const _hoisted_38 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_39 = { class: "px-5 py-2" }
const _hoisted_40 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_41 = { class: "px-5 py-2" }
const _hoisted_42 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_43 = { class: "px-5 py-2" }
const _hoisted_44 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_45 = { class: "px-5 py-2" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "subtitle-wrapper pa-1 px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_eating_status_item = _resolveComponent("eating-status-item")!
  const _component_sleep_list = _resolveComponent("sleep-list")!
  const _component_sleep_modal = _resolveComponent("sleep-modal")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_temperature_list = _resolveComponent("temperature-list")!
  const _component_temperature_modal = _resolveComponent("temperature-modal")!
  const _component_breakfast_list = _resolveComponent("breakfast-list")!
  const _component_breakfast_modal = _resolveComponent("breakfast-modal")!
  const _component_dinner_list = _resolveComponent("dinner-list")!
  const _component_dinner_modal = _resolveComponent("dinner-modal")!
  const _component_milk_list = _resolveComponent("milk-list")!
  const _component_milk_modal = _resolveComponent("milk-modal")!
  const _component_defecation_list = _resolveComponent("defecation-list")!
  const _component_defecation_modal = _resolveComponent("defecation-modal")!
  const _component_state_of_child_form = _resolveComponent("state-of-child-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, { color: "primary" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.routerBack,
            style: {"z-index":"1"},
            icon: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, {
            style: {"position":"absolute","left":"50%","transform":"translateX(-50%)","margin":"0","padding":"0","max-width":"60%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.childName), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_btn, {
              onClick: _ctx.toChat,
              icon: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('record.menu.chat', 'チャット')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        tile: "",
        elevation: "0",
        style: {"height":"60px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.year), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_v_btn, {
                onClick: _ctx.toPrevDate,
                class: "record-date-nav-btn no-background-hover",
                color: "primary",
                variant: "outlined--text",
                dark: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('record.date.prevDay', '前の日')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.today), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(`(${_ctx.dayOfTheWeek})`), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_v_btn, {
                onClick: _ctx.toNextDate,
                class: "record-date-nav-btn no-background-hover",
                color: "primary",
                variant: "outlined--text",
                dark: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('record.date.nextDay', '次の日')), 1),
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }),
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "grey-border" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.nurseryRecord', 'Nursery records')), 1)
      ]),
      (_ctx.nurseryLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_vue_loading, {
              active: _ctx.nurseryLoading,
              loader: "bars",
              color: "#EE6090",
              size: { width: '30px', height: '30px' }
            }, null, 8, ["active"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.attendance', '登降園時間')), 1)
            ]),
            (_ctx.attendance && (_ctx.attendance.attendedAt || _ctx.attendance.leftAt))
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.minuteFormat(_ctx.attendance.attendedAt)) + " 〜 " + _toDisplayString(_ctx.minuteFormat(_ctx.attendance.leftAt)) + " ", 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.t('record.date.editedAt', '（編集 {time}）', { time: _ctx.minuteFormat(_ctx.attendance.updatedAt) })), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.sleep', '睡眠時間')), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nursery?.sleeps, (s) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex pa-2",
                key: s.sleepId
              }, [
                _createElementVNode("p", null, _toDisplayString(_ctx.minuteFormat(s.from)) + " 〜 " + _toDisplayString(_ctx.minuteFormat(s.to)), 1)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.meal', '喫食')), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_22, [
                (Array.isArray(_ctx.meals) && _ctx.meals.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.meals, (m) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: m.key,
                        class: "pa-1"
                      }, [
                        (m && m.item)
                          ? (_openBlock(), _createBlock(_component_eating_status_item, {
                              key: 0,
                              text: m.text,
                              item: m.item
                            }, null, 8, ["text", "item"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.mealComment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.t('record.section.mealComment', 'コメント')), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.mealComment || ''), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.defecation', '排便')), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nursery?.defecations, (d) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex pa-2",
                key: d.defecationId
              }, [
                _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.minuteFormat(d.recordedAt)), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.getDefecationState(d.state)), 1)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.milk', 'ミルク')), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nursery?.milks, (m) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex pa-2",
                key: m.milkId
              }, [
                _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.minuteFormat(m.recordedAt)), 1),
                _createElementVNode("p", null, _toDisplayString(`${_ctx.categoryToText(m.milkCategory)}  ${
                m.amount ? m.amount.value + 'cc' : _ctx.t('common.unknown', '不明')
              }`), 1)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.temperature', '体温')), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nursery?.temperatures, (t) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex pa-2",
                key: t.temperatureId
              }, [
                _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.minuteFormat(t.recordedAt)), 1),
                _createElementVNode("p", null, _toDisplayString(t.temperature) + "℃", 1)
              ]))
            }), 128))
          ])),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.homeRecord', 'Home records')), 1)
      ]),
      (_ctx.homeLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createVNode(_component_vue_loading, {
              active: _ctx.homeLoading,
              loader: "bars",
              color: "#EE6090",
              size: { width: '30px', height: '30px' }
            }, null, 8, ["active"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.sleep', '睡眠時間')), 1)
            ]),
            _createVNode(_component_sleep_list, {
              sleeps: _ctx.home.sleeps
            }, null, 8, ["sleeps"]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_v_btn, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSleepDialog = true)),
                color: "primary",
                variant: "outlined",
                block: "",
                small: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('record.action.addSleep', '睡眠記録を追加')), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_v_dialog, {
              modelValue: _ctx.isSleepDialog,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isSleepDialog) = $event)),
              persistent: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_sleep_modal, {
                  isOpen: _ctx.isSleepDialog,
                  childId: _ctx.childId,
                  selectedDate: _ctx.selectedDate,
                  onPosted: _ctx.fetchReport,
                  onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSleepDialog = false))
                }, null, 8, ["isOpen", "childId", "selectedDate", "onPosted"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.temperature', '体温')), 1)
            ]),
            _createVNode(_component_temperature_list, {
              temperatures: _ctx.home.temperatures
            }, null, 8, ["temperatures"]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_v_btn, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isTemperatureDialog = true)),
                color: "primary",
                variant: "outlined",
                block: "",
                small: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('record.action.addTemperature', '体温記録を追加')), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_v_dialog, {
              modelValue: _ctx.isTemperatureDialog,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isTemperatureDialog) = $event)),
              persistent: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_temperature_modal, {
                  isOpen: _ctx.isTemperatureDialog,
                  childId: _ctx.childId,
                  selectedDate: _ctx.selectedDate,
                  onPosted: _ctx.fetchReport,
                  onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isTemperatureDialog = false))
                }, null, 8, ["isOpen", "childId", "selectedDate", "onPosted"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.breakfast', '朝食')), 1)
            ]),
            _createVNode(_component_breakfast_list, {
              breakfasts: _ctx.home.breakfasts,
              childId: _ctx.childId,
              selectedDate: _ctx.selectedDate,
              onEdited: _ctx.fetchReport
            }, null, 8, ["breakfasts", "childId", "selectedDate", "onEdited"]),
            _withDirectives(_createElementVNode("div", _hoisted_39, [
              _createVNode(_component_v_btn, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isBreakfastDialog = true)),
                color: "primary",
                variant: "outlined",
                block: "",
                small: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('record.action.addBreakfast', '朝食記録を追加')), 1)
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, _ctx.home.breakfasts.length === 0]
            ]),
            _createVNode(_component_v_dialog, {
              modelValue: _ctx.isBreakfastDialog,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isBreakfastDialog) = $event)),
              persistent: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_breakfast_modal, {
                  isOpen: _ctx.isBreakfastDialog,
                  childId: _ctx.childId,
                  selectedDate: _ctx.selectedDate,
                  onPosted: _ctx.fetchReport,
                  onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isBreakfastDialog = false))
                }, null, 8, ["isOpen", "childId", "selectedDate", "onPosted"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.dinner', '夕食')), 1)
            ]),
            _createVNode(_component_dinner_list, {
              dinners: _ctx.home.dinners,
              childId: _ctx.childId,
              selectedDate: _ctx.selectedDate,
              onEdited: _ctx.fetchReport
            }, null, 8, ["dinners", "childId", "selectedDate", "onEdited"]),
            _withDirectives(_createElementVNode("div", _hoisted_41, [
              _createVNode(_component_v_btn, {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isDinnerDialog = true)),
                color: "primary",
                variant: "outlined",
                block: "",
                small: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('record.action.addDinner', '夕食記録を追加')), 1)
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, _ctx.home.dinners.length === 0]
            ]),
            _createVNode(_component_v_dialog, {
              modelValue: _ctx.isDinnerDialog,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isDinnerDialog) = $event)),
              persistent: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_dinner_modal, {
                  isOpen: _ctx.isDinnerDialog,
                  childId: _ctx.childId,
                  selectedDate: _ctx.selectedDate,
                  onPosted: _ctx.fetchReport,
                  onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isDinnerDialog = false))
                }, null, 8, ["isOpen", "childId", "selectedDate", "onPosted"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.milk', 'ミルク')), 1)
            ]),
            _createVNode(_component_milk_list, {
              milks: _ctx.home.milks
            }, null, 8, ["milks"]),
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_v_btn, {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isMilkDialog = true)),
                color: "primary",
                variant: "outlined",
                block: "",
                small: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('record.action.addMilk', 'ミルク記録を追加')), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_v_dialog, {
              modelValue: _ctx.isMilkDialog,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isMilkDialog) = $event)),
              persistent: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_milk_modal, {
                  isOpen: _ctx.isMilkDialog,
                  childId: _ctx.childId,
                  selectedDate: _ctx.selectedDate,
                  onPosted: _ctx.fetchReport,
                  onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isMilkDialog = false))
                }, null, 8, ["isOpen", "childId", "selectedDate", "onPosted"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.defecation', '排便')), 1)
            ]),
            _createVNode(_component_defecation_list, {
              defecations: _ctx.home.defecations
            }, null, 8, ["defecations"]),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_v_btn, {
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isDefecationDialog = true)),
                color: "primary",
                variant: "outlined",
                block: "",
                small: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('record.action.addDefecation', '排便記録を追加')), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_v_dialog, {
              modelValue: _ctx.isDefecationDialog,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isDefecationDialog) = $event)),
              persistent: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_defecation_modal, {
                  isOpen: _ctx.isDefecationDialog,
                  childId: _ctx.childId,
                  selectedDate: _ctx.selectedDate,
                  onPosted: _ctx.fetchReport,
                  onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isDefecationDialog = false))
                }, null, 8, ["isOpen", "childId", "selectedDate", "onPosted"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (!_ctx.isChatEnabled && _ctx.home.stateOfChild)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.t('record.section.childRecord', 'お子様の記録')), 1)
                  ]),
                  _createVNode(_component_state_of_child_form, {
                    isDraft: _ctx.home.stateOfChild.isDraft,
                    body: _ctx.home.stateOfChild.body,
                    childId: _ctx.childId,
                    selectedDate: _ctx.selectedDate,
                    onPosted: _ctx.fetchReport
                  }, null, 8, ["isDraft", "body", "childId", "selectedDate", "onPosted"])
                ]))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}